import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M2 11a1 1 0 0 1 1-1h4v11H3a1 1 0 0 1-1-1v-9Zm15.382 10H9a1 1 0 0 1-1-1v-9.63a1 1 0 0 1 .24-.65l5.175-6.037a.833.833 0 0 1 1.422.805L13.44 8.684A1 1 0 0 0 14.387 10H21a1 1 0 0 1 1 1v1.764a1 1 0 0 1-.106.447l-3.618 7.236a1 1 0 0 1-.894.553Z" }, null, -1), c = [
  n
];
function l(r, s) {
  return e(), t("svg", a, [...c]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
